import projection from '../generated/pwh5m8f1.json';
import { AcceptanceManifest } from '../types';
export const pwh5m8f1AcceptanceManifest = projection as AcceptanceManifest;
